import { NavLink } from 'react-router-dom';
import { useMemo, useState } from 'react';
import useAppStore from '../../store/app.store';
import { IcX, IcChevronLeft, IcChevronRight } from '../ui/Icons';

// ─── Ícones SVG ───────────────────────────────────────────────────────────────
const Icon = ({ paths, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
    {paths.map((d, i) => <path key={i} d={d} />)}
  </svg>
);

const ICONS = {
  dashboard:      <Icon paths={['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z','M9 22V12h6v10']} />,
  chamados:       <Icon paths={['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z','M14 2v6h6','M16 13H8','M16 17H8','M10 9H8']} />,
  recorrentes:    <Icon paths={['M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83']} />,
  reunioes:       <Icon paths={['M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z']} />,
  chat:           <Icon paths={['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z']} />,
  midias: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <circle cx="12" cy="12" r="4"/>
      <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
    </svg>
  ),
  trafego:        <Icon paths={['M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z','M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z','M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z','M12 2v2M12 20v2M2 12h2M20 12h2']} />,
  acompanhamento: <Icon paths={['M18 20V10','M12 20V4','M6 20v-6']} />,
  comercial:      <Icon paths={['M22 12h-4l-3 9L9 3l-3 9H2']} />,
  crm:            <Icon paths={['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2','M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z','M23 21v-2a4 4 0 0 0-3-3.87','M16 3.13a4 4 0 0 1 0 7.75']} />,
  financeiro:     <Icon paths={['M12 1v22','M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6']} />,
  clientes:       <Icon paths={['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2','M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z']} />,
  contratos:      <Icon paths={['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z','M14 2v6h6','M12 18v-6','M9 15h6']} />,
  pauta:          <Icon paths={['M9 11l3 3L22 4','M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11']} />,
  equipe:         <Icon paths={['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2','M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z','M23 21v-2a4 4 0 0 0-3-3.87','M16 3.13a4 4 0 0 1 0 7.75']} />,
  rotinas:        <Icon paths={['M17 1l4 4-4 4','M3 11V9a4 4 0 0 1 4-4h14','M7 23l-4-4 4-4','M21 13v2a4 4 0 0 1-4 4H3']} />,
  projetos:       <Icon paths={['M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z','M8 13l2.5 2.5L16 10']} />,
  admin:          <Icon paths={['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z','M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z']} />,
};

const NAV_GROUPS = [
  {
    label: 'Trabalho',
    items: [
      { path: '/pauta',          label: 'Minha pauta',      icon: ICONS.pauta,          modulo: 'pauta'          },
      { path: '/equipe',         label: 'Equipe',           icon: ICONS.equipe,         modulo: 'equipe'         },
      { path: '/rotinas',        label: 'Rotinas',          icon: ICONS.rotinas,        modulo: 'rotinas'        },
    ],
  },
  {
    label: 'Gestão',
    items: [
      { path: '/dashboard',      label: 'Dashboard',        icon: ICONS.dashboard,      modulo: 'dashboard'      },
      { path: '/chamados',       label: 'Chamados',         icon: ICONS.chamados,       modulo: 'chamados'       },
      { path: '/recorrentes',    label: 'Recorrentes',      icon: ICONS.recorrentes,    modulo: 'chamados'       },
      { path: '/projetos',       label: 'Projetos',         icon: ICONS.projetos,       modulo: 'projetos'       },
      { path: '/reunioes',       label: 'Reuniões',         icon: ICONS.reunioes,       modulo: 'reunioes'       },
      { path: '/chat',           label: 'Chat',             icon: ICONS.chat,           modulo: 'chat'           },
    ],
  },
  {
    label: 'Operacional',
    items: [
      { path: '/midias',         label: 'Mídias Sociais',   icon: ICONS.midias,         modulo: 'midias'         },
      { path: '/trafego',        label: 'Tráfego Pago',     icon: ICONS.trafego,        modulo: 'trafego'        },
      { path: '/comercial',      label: 'Acomp. Comercial', icon: ICONS.comercial,      modulo: 'comercial'      },
    ],
  },
  {
    label: 'Comercial',
    items: [
      { path: '/crm',            label: 'CRM Interno',      icon: ICONS.crm,            modulo: 'crm'            },
    ],
  },
  {
    label: 'Gestão',
    items: [
      { path: '/financeiro',     label: 'Financeiro',       icon: ICONS.financeiro,     modulo: 'financeiro'     },
      { path: '/clientes',       label: 'Clientes',         icon: ICONS.clientes,       modulo: 'clientes'       },
      { path: '/admin',          label: 'Administração',    icon: ICONS.admin,           modulo: 'admin'          },
    ],
  },
];

// ─── Alturas fixas para o cálculo do nav ──────────────────────────────────────
const LOGO_H   = 60;  // px — mesma altura do topbar
const CAL_H    = 200; // px

// ─── Mini Calendário ───────────────────────────────────────────────────────────
const DIAS_SEMANA = ['D','S','T','Q','Q','S','S'];
const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

function MiniCalendario({ usuarioId }) {
  const producoes = useAppStore(s => s.producoes);
  const chamados  = useAppStore(s => s.chamados);
  const hoje = new Date();
  const [offset, setOffset] = useState(0);

  const dataRef  = new Date(hoje.getFullYear(), hoje.getMonth() + offset, 1);
  const ano      = dataRef.getFullYear();
  const mes      = dataRef.getMonth();
  const diaHoje  = hoje.getDate();
  const mesAtual = offset === 0;

  const diasComPrazo = useMemo(() => {
    const set = new Set();
    producoes.forEach(p => {
      if (p.responsavel_id === usuarioId && p.prazo && p.status !== 'publicado') {
        const d = new Date(p.prazo);
        if (d.getFullYear() === ano && d.getMonth() === mes) set.add(d.getDate());
      }
    });
    chamados.forEach(c => {
      if (c.responsavel_id === usuarioId && c.data_prazo && !['concluido','cancelado'].includes(c.status)) {
        const d = new Date(c.data_prazo);
        if (d.getFullYear() === ano && d.getMonth() === mes) set.add(d.getDate());
      }
    });
    return set;
  }, [producoes, chamados, usuarioId, ano, mes]);

  const primeiroDia = new Date(ano, mes, 1).getDay();
  const ultimoDia   = new Date(ano, mes + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < primeiroDia; i++) cells.push(null);
  for (let d = 1; d <= ultimoDia; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  return (
    <div style={{
      height: CAL_H,
      flexShrink: 0,
      padding: '10px 16px 20px',
      borderTop: '1px solid rgba(255,255,255,.07)',
    }}>
      {/* Cabeçalho mês */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 7 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <button onClick={() => setOffset(o => o - 1)} aria-label="Mês anterior"
            style={{ color: '#94A3B8', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', padding: '0 4px' }}>
            <IcChevronLeft size={14} />
          </button>
          <span style={{ fontSize: 11, fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: 1, width: 64, textAlign: 'center' }}>
            {MESES[mes]} {ano}
          </span>
          <button onClick={() => setOffset(o => o + 1)} aria-label="Próximo mês"
            style={{ color: '#94A3B8', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', padding: '0 4px' }}>
            <IcChevronRight size={14} />
          </button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          {!mesAtual && (
            <button onClick={() => setOffset(0)}
              style={{ fontSize: 10, color: '#6C4CF5', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700 }}>
              hoje
            </button>
          )}
          <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#EF4444', display: 'inline-block' }} />
            <span style={{ fontSize: 10, color: '#64748B' }}>prazo</span>
          </span>
        </div>
      </div>

      {/* Letras dos dias */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', marginBottom: 3 }}>
        {DIAS_SEMANA.map((d, i) => (
          <div key={i} style={{ textAlign: 'center', fontSize: 10, fontWeight: 700, color: '#3B4F72' }}>{d}</div>
        ))}
      </div>

      {/* Grade */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)' }}>
        {cells.map((dia, i) => {
          if (!dia) return <div key={i} />;
          const isHoje   = mesAtual && dia === diaHoje;
          const temPrazo = diasComPrazo.has(dia);
          const passado  = mesAtual && dia < diaHoje;
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1px 0' }}>
              <div style={{
                width: 24, height: 24,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                borderRadius: '50%',
                fontSize: 10, fontWeight: isHoje ? 700 : 400,
                position: 'relative',
                background: isHoje ? '#6C4CF5' : 'transparent',
                color: isHoje ? '#fff' : passado ? '#2A3652' : '#94A3B8',
              }}>
                {dia}
                {temPrazo && (
                  <span style={{
                    position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
                    width: 4, height: 4, borderRadius: '50%',
                    background: isHoje ? '#FDE047' : '#EF4444',
                  }} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── Sidebar ──────────────────────────────────────────────────────────────────
export default function Sidebar({ open, onClose }) {
  const usuario        = useAppStore(s => s.usuario);
  const chat_mensagens = useAppStore(s => s.chat_mensagens);

  const chatNaoLidas = chat_mensagens
    ? chat_mensagens.filter(m => m.para_id === usuario?.id && !m.lida).length
    : 0;

  const itensVisiveis = (items) =>
    usuario?.nivel_acesso <= 1
      ? items
      : items.filter(item => item.modulo === 'pauta');

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/50 z-20 lg:hidden" onClick={onClose} aria-hidden="true" />
      )}

      <aside
        role="navigation"
        aria-label="Menu principal"
        className={`
          fixed top-0 left-0 z-30
          transition-transform duration-300
          ${open ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0 lg:static
        `}
        style={{
          width: 280,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          background: '#0B1220',
          borderRight: '1px solid #2A3652',
        }}
      >

        {/* ── Logo ── */}
        <div style={{
          height: 60,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 16px',
          borderBottom: '1px solid #2A3652',
          position: 'relative',
          overflow: 'hidden',
          background: '#131D31',
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, lineHeight: 1 }}>
            <span style={{
              fontFamily: "'Rajdhani', 'Barlow', 'Arial Black', sans-serif",
              fontSize: 24,
              fontWeight: 800,
              letterSpacing: '0.22em',
              color: '#FFFFFF',
              textTransform: 'uppercase',
              lineHeight: 1,
            }}>LEGACY</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ height: 1, width: 26, background: '#C9922A' }} />
              <span style={{
                fontFamily: "'Rajdhani', 'Barlow', 'Arial Black', sans-serif",
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: '0.42em',
                color: '#C9922A',
                textTransform: 'uppercase',
              }}>HUB</span>
              <div style={{ height: 1, width: 26, background: '#C9922A' }} />
            </div>
          </div>
          <button onClick={onClose} aria-label="Fechar menu" className="lg:hidden"
            style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', right: 14, color: '#6E7A96', background: 'none', border: 'none', cursor: 'pointer', display: 'flex' }}>
            <IcX size={16} />
          </button>
        </div>

        {/* ── Navegação (altura calculada para não precisar de scroll) ── */}
        <nav
          aria-label="Navegação"
          style={{
            height: `calc(100vh - ${LOGO_H}px - ${CAL_H}px)`,
            flexShrink: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '4px 10px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {NAV_GROUPS.map(group => {
            const visíveis = itensVisiveis(group.items);
            if (visíveis.length === 0) return null;
            return (
              <div key={group.label}>
                <p style={{
                  color: '#4B5E82',
                  fontSize: 10,
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  fontWeight: 700,
                  margin: '10px 8px 3px',
                }}>
                  {group.label}
                </p>

                {visíveis.map(item => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    onClick={onClose}
                    aria-label={item.label}
                    style={({ isActive }) => ({
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      textDecoration: 'none',
                      color: isActive ? '#FFFFFF' : '#94A3B8',
                      padding: '9px 12px',
                      borderRadius: 10,
                      marginBottom: 1,
                      fontWeight: isActive ? 600 : 400,
                      fontSize: 14,
                      lineHeight: 1,
                      background: isActive ? 'linear-gradient(90deg,#6C4CF5,#7A5CFF)' : 'transparent',
                      boxShadow: isActive ? '0 6px 16px rgba(108,76,245,.3)' : 'none',
                      transition: 'background .15s, color .15s',
                    })}
                    onMouseEnter={e => {
                      const s = e.currentTarget.style;
                      if (!s.boxShadow || s.boxShadow === 'none') s.background = '#152036';
                    }}
                    onMouseLeave={e => {
                      const s = e.currentTarget.style;
                      if (!s.boxShadow || s.boxShadow === 'none') s.background = 'transparent';
                    }}
                  >
                    {item.icon}
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {item.modulo === 'chat' && chatNaoLidas > 0 && (
                      <span style={{
                        background: '#EF4444', color: '#fff',
                        fontSize: 9, fontWeight: 700,
                        padding: '2px 6px', borderRadius: 999,
                      }}>
                        {chatNaoLidas > 99 ? '99+' : chatNaoLidas}
                      </span>
                    )}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>

        {/* ── Calendário (altura fixa CAL_H) ── */}
        {usuario && <MiniCalendario usuarioId={usuario.id} />}

      </aside>
    </>
  );
}
